// src/utils/images.js
// Simple, network-free SVG avatar generator.

const toInitials = (nameOrEmail = "", fallback = "U") => {
  const s = String(nameOrEmail).trim();
  if (!s) return fallback;
  // Try two initials from name, else first char
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return s[0].toUpperCase();
};

export const makeAvatarDataUrl = (
  text = "Dr",
  { size = 48, bg = "#4F46E5", fg = "#FFFFFF", rounded = true } = {}
) => {
  const radius = rounded ? size / 2 : 8;
  const svg = `
    <svg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}' viewBox='0 0 ${size} ${size}'>
      <defs>
        <linearGradient id='g' x1='0' x2='1' y1='0' y2='1'>
          <stop offset='0%' stop-color='${bg}' />
          <stop offset='100%' stop-color='#7C3AED' />
        </linearGradient>
      </defs>
      <rect x='0' y='0' width='${size}' height='${size}' rx='${radius}' ry='${radius}' fill='url(#g)'/>
      <text x='50%' y='54%' dominant-baseline='middle' text-anchor='middle'
            font-family='Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial'
            font-weight='700' font-size='${Math.round(size * 0.42)}' fill='${fg}'>
        ${text}
      </text>
    </svg>
  `;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

export const makeDoctorAvatar = (name) =>
  makeAvatarDataUrl("Dr", { size: 48 }); // Keep “Dr” brand for doctors

export const makeUserAvatar = (nameOrEmail) =>
  makeAvatarDataUrl(toInitials(nameOrEmail || "U"), { size: 36, rounded: true });
